<template>
  <div class="timeBox">
    <span class="time">{{ formatDate }}</span>
    <span class="time">{{ day }}</span>
    <span>{{ formatTime }}</span>
  </div>
</template>

<script>
export default {
  name: 'time-box',
  data() {
    return {
      timer: null,
      date: new Date(),
    };
  },
  computed: {
    formatDate() {
      return this.$formatDate(this.date, 'yyyy-MM-dd');
    },
    day() {
      return this.$parseTime(this.date, '星期{a}');
    },
    formatTime() {
      return this.$formatDate(this.date, 'hh:mm:ss');
    },
  },
  created() {
    this.startTimer();
  },
  destroyed() {
    cancelAnimationFrame(this.timer);
  },
  methods: {
    startTimer() {
      this.timer = requestAnimationFrame(() => {
        this.date = new Date();
        this.startTimer();
      });
    },
  },
};
</script>

<style lang="scss">
.timeBox {
  color: #fff;
  .time {
    margin-right: 4px;
  }
}
</style>
